import _asyncToGenerator from "@babel/runtime/helpers/asyncToGenerator";
import _regeneratorRuntime from "@babel/runtime/regenerator";
import { fetchUpdateOfferFolders } from '../repositories/favorites/v1/update-offer-folders';
export var updateOfferFolders = function updateOfferFolders(offerId, folderIds) {
  return /*#__PURE__*/function () {
    var _ref2 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee(dispatch, getState, _ref) {
      var httpApi, logger, parameters, _yield$fetchUpdateOff, statusCode;
      return _regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) switch (_context.prev = _context.next) {
          case 0:
            httpApi = _ref.httpApi, logger = _ref.logger;
            parameters = {
              offerId: offerId,
              folderIds: folderIds
            };
            _context.prev = 2;
            _context.next = 5;
            return fetchUpdateOfferFolders({
              httpApi: httpApi,
              parameters: parameters
            });
          case 5:
            _yield$fetchUpdateOff = _context.sent;
            statusCode = _yield$fetchUpdateOff.statusCode;
            if (!(statusCode === 200)) {
              _context.next = 9;
              break;
            }
            return _context.abrupt("return", true);
          case 9:
            _context.next = 14;
            break;
          case 11:
            _context.prev = 11;
            _context.t0 = _context["catch"](2);
            logger.error(_context.t0, {
              description: 'Fail to update favorites folders'
            });
          case 14:
            return _context.abrupt("return", false);
          case 15:
          case "end":
            return _context.stop();
        }
      }, _callee, null, [[2, 11]]);
    }));
    return function (_x, _x2, _x3) {
      return _ref2.apply(this, arguments);
    };
  }();
};